import { createContext } from 'react';
import { ITheme } from '../themes/models';
import { NoneTheme } from '../themes/none';
import { ConfigParams } from '../utils';

export const ConfigContext = createContext<{ config: ConfigParams, theme: ITheme }>({ config: {}, theme: new NoneTheme() });

export const ConfigProvider = ConfigContext.Provider;